import React from "react";
import "./experience.css";

const skillGroups = [
  {
    title: "Frontend",
    items: [
      { name: "React.js", level: "Expert" },
      { name: "Next.js", level: "Expert" },
      { name: "TypeScript", level: "Expert" },
      { name: "React Native", level: "Advanced" },
      { name: "Three.js", level: "Advanced" },
      { name: "JavaScript", level: "Expert" },
      { name: "Tailwind CSS", level: "Expert" },
    ],
  },
  {
    title: "Backend",
    items: [
      { name: "NestJS", level: "Expert" },
      { name: "Python", level: "Expert" },
      { name: "Node.js", level: "Advanced" },
      { name: "MongoDB", level: "Advanced" },
      { name: "MySQL", level: "Advanced" },
      { name: "ASP.NET Core", level: "Advanced" },
      { name: "PHP", level: "Intermediate" },
    ],
  },
  {
    title: "Cloud & Infra",
    items: [
      { name: "Git", level: "Expert" },
      { name: "Docker", level: "Advanced" },
      { name: "AWS", level: "Advanced" },
      { name: "GCP", level: "Advanced" },
      { name: "Terraform", level: "Advanced" },
    ],
  },
];

const levelColors = {
  Expert: "skill--expert",
  Advanced: "skill--advanced",
  Intermediate: "skill--intermediate",
};

const Experience = () => {
  return (
    <section id="skills" aria-labelledby="skills-heading">
      <h5>What I work with</h5>
      <h2 id="skills-heading">Skills</h2>

      <div className="container experience__grid reveal">
        {skillGroups.map((group) => (
          <article
            key={group.title}
            className="experience__card glass pixel-corners"
          >
            <h3 className="experience__card-title">{group.title}</h3>
            <div className="experience__skills">
              {group.items.map((item) => (
                <div
                  key={item.name}
                  className={`skill-chip ${levelColors[item.level] || ""}`}
                >
                  <div className="skill-chip__header">
                    <span className="skill-chip__name">{item.name}</span>
                    <span className="skill-chip__dot" />
                    <span className="skill-chip__level">{item.level}</span>
                  </div>
                  <div className="skill-bar">
                    <div className="skill-bar__fill" />
                  </div>
                </div>
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Experience;
